import { GET_ADMIN_CHATS, GET_ADMIN_RECIPIENTS, GET_ADMIN_SETTINGS, GET_ADMIN_SOLUTIONS, SEND_ADMIN_MESSAGE, SET_SOLUTION_APPROVAL, UPDATE_ADMIN_SETTINGS } from "../actions/admin";
import { mapInboxToCard } from "./mapInboxToCard";


export const admin = {

  [GET_ADMIN_CHATS]: async ({ api }) => {
    const response = await api.admin.getChats();
    // newest first, same as notifications (src/application/middleware/notifications.js)
    return response.data?.map(mapInboxToCard).sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
  },

  [GET_ADMIN_RECIPIENTS]: async ({ api }) => {
    const response = await api.admin.getRecipients();
    return response.data;
  },

  [SEND_ADMIN_MESSAGE]: async ({ api, action }) => {
    const response = await api.admin.sendMessage(action.payload);
    return response.data;
  },

  [GET_ADMIN_SETTINGS]: async ({ api }) => {
    const response = await api.admin.getSettings();
    return response.data;
  },

  [UPDATE_ADMIN_SETTINGS]: async ({ api, action }) => {
    const response = await api.admin.updateSettings(action.payload);
    return response.data;
  },

  [GET_ADMIN_SOLUTIONS]: async ({ api, action }) => {
    const response = await api.admin.getSolutions(action.payload);
    return response.data;
  },

  [SET_SOLUTION_APPROVAL]: async ({ api, action }) => {
    const response = await api.admin.setSolutionApproval(action.payload);
    return response.data;
  },

}
